import React, { useState } from "react";
import { DialogActions, DialogContent, Tab } from "@mui/material";
import { LoadingButton, TabContext, TabList, TabPanel } from "@mui/lab";

import CommonDialog from "app/components/common/Dialogs/CommonDialog";
import AddExpenseSubHead from "app/components/common/Dialogs/AddExpenseSubHead";
import { TabsWrapper } from "assets/styles/globalStyledComponent";
import CompletedExpenseForm from "./CompletedExpenseForm";
import RequestExpenseForm from "./RequestExpenseForm";

const ExpensesDialog = ({ dialogs, setDialogs, refetch = () => {} }) => {
  const [activeTab, setActiveTab] = useState("1");
  const [openExpenseSubHeadDialog, setOpenExpenseSubHeadDialog] = useState(false);
  const [currentHeadId, setCurrentHeadId] = useState("");

  const handleClose = () => {
    setDialogs((prev) => ({
      ...prev,
      add: false,
      subHead: "",
    }));
    setActiveTab("1");
  };

  const handleSuccess = () => {
    handleClose();
    refetch();
  };

  const handleOpenSubHeadDialog = (headId) => {
    setCurrentHeadId(headId);
    setOpenExpenseSubHeadDialog(true);
  };

  const handleCloseSubHeadDialog = () => {
    setOpenExpenseSubHeadDialog(false);
    setCurrentHeadId("");
  };

  return (
    <>
      <AddExpenseSubHead
        open={openExpenseSubHeadDialog}
        handleClose={handleCloseSubHeadDialog}
        headId={currentHeadId}
      />

      <CommonDialog
        open={dialogs?.add}
        onClose={handleClose}
        minWidth="700px"
        title="Add Expense"
      >
        <DialogContent>
          <TabContext value={activeTab}>
            <TabsWrapper>
              <TabList
                onChange={(e, newValue) => {
                  setActiveTab(newValue);
                }}
              >
                <Tab label="Add Completed Expense" value="1" />
                <Tab label="Request Expense" value="2" />
              </TabList>
            </TabsWrapper>

            <TabPanel value="1" sx={{ p: "0 !important" }}>
              <CompletedExpenseForm
                dialogs={dialogs}
                onSuccess={handleSuccess}
                onOpenSubHeadDialog={handleOpenSubHeadDialog}
              />
            </TabPanel>

            <TabPanel
              value="2"
              sx={{
                p: "0 !important",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <RequestExpenseForm
                dialogs={dialogs}
                onSuccess={handleSuccess}
                onOpenSubHeadDialog={handleOpenSubHeadDialog}
              />
            </TabPanel>
          </TabContext>
        </DialogContent>

        <DialogActions>
          <LoadingButton
            form={activeTab === "2" ? "reqExpForm" : "comp-exp-pay"}
            type="submit"
            variant={activeTab === "2" ? "outlined" : "contained"}
            color={activeTab === "2" ? "warning" : "secondary"}
            size="large"
          >
            {activeTab === "2" ? "Send For Approval" : "Submit"}
          </LoadingButton>
        </DialogActions>
      </CommonDialog>
    </>
  );
};

export default ExpensesDialog;
